export default {
    formatPrice(price) {
        if (price === undefined || price === null) return ''
        return price.toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL'
        })
    }
}